import { linklistApi } from '@/utils/axios-config';

export default {
    get(link_slug) {
        return linklistApi.get(`/links/${link_slug}/`);
    },
    create(organisation_slug, tree_slug, data) {
        return linklistApi.post(
            `/organisations/${organisation_slug}/link-trees/${tree_slug}/links`,
            data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        );
    },
    delete(link_slug) {
        return linklistApi.delete(`/links/${link_slug}/`);
    },
    incrementClicks(link_slug) {
        return linklistApi.patch(`/links/${link_slug}/click`);
    },
    update(link_slug, data) {
        data.delete('type');

        return linklistApi.post(`/links/${link_slug}/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    uploadImage(data) {
        return linklistApi.post(`/images/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    getStats(link_slug, data) {
        let paramString = Object.entries(data)
            .map(([key, val]) => `${key}=${val}`)
            .join('&');
        return linklistApi.get(`/links/${link_slug}/stats?${paramString}`);
    },
};
